import React, { Component } from "react";
import { Redirect, Switch, Route, Link } from "react-router-dom";
import { withRouter } from "react-router";
import * as aserver from '../../APIClient';
import clsx from 'clsx';
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Button from '@material-ui/core/Button';
import MenuIcon from "@material-ui/icons/Menu";
import AppBar from '@material-ui/core/AppBar';
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Dashboard from '../home/Home';
import Template from '../pages/templates';
import Teams from '../generalTables/teams';
import Couples from '../generalTables/couples';
import { MiniAssessments } from '../generalTables/mini-assessments';
import Billing from '../pages/billing';
import Orders from '../pages/orders';
import Messages from "../pages/messages";
import Help from '../pages/help';
import Profile from '../pages/userProfile';
// import Clients from '../generalTables/clients';
import Assessments from '../generalTables/assessments';
import Samples from '../pages/sample';
import TeamMembers from '../generalTables/teamMembers';
import CssBaseline from '@material-ui/core/CssBaseline';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Header from "./title";
import { purple } from '@material-ui/core/colors';
import ListItemText from '@material-ui/core/ListItemText';
import Backdrop from '@material-ui/core/Backdrop';
import Paper from '@material-ui/core/Paper';
import Badge from '@material-ui/core/Badge';
import {isMobile} from 'react-device-detect';
// import Logo from "../images/Aephoria-logo-blue.png"
import WhiteLogo from "../images/AIM Leaf Inverted.png"
import WhiteLogoSafeTest from "../images/AIM Leaf Inverted Safe Test.png"
import DashboardIcon from "../images/dashboard.png"
import AssessmentsIcon from "../images/assessments.png"
import BalanceIcon from "../images/balance.png"
import TeamsIcon from "../images/teams.png"
import EmailIcon from "../images/email.png"
import MessagesIcon from "../images/messages.png"
import SamplesIcon from "../images/samples.png"
import HelpIcon from "../images/help.png"
import UserIcon from "../images/user.png"
import LogoutIcon from "../images/logout.png"
import AephoriaLabLogo from "../images/Aephoria Lab Logo.png"
import Notepad from "../images/Option 1.jpg" // https://codesandbox.io/p/sandbox/eyes-follow-mouse-cursor-o577x
import Modal from '../comps/modal';
import Toast from "../comps/alertMessage";

const drawerWidth = 250;

const styles = theme => ({
    root: {
        display: 'flex',
      },
      palette: {
        primary: {
          // Purple and green play nicely together.
          main: purple[500],
        },
        secondary: {
          // This is green.A700 as hex.
          main: '#11cb5f',
        },
      },
      badgeContent:{
        marginRight:20,
      },
      toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        // justifyContent: 'flex-end',
        padding: '0',
        ...theme.mixins.toolbar,
      },
      appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
      },
      appBarShift: {
        marginLeft: drawerWidth,
        width:isMobile?"" :`calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
      menuButton: {
        marginRight: 36,
      },
      menuButtonHidden: {
        display: 'none',
      },
      title: {
        flexGrow: 1,
      },
      drawerPaper: {
        position:isMobile?"fixed":'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        zIndex: isMobile?99999:10,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
      drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: isMobile?0:theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: isMobile?0:theme.spacing(9),
        },
      },
      appBarSpacer: theme.mixins.toolbar,
      content: {
        flexGrow: 1,
        height: isMobile?'90vh':"100vh",
        overflowY: "auto",
      },
      container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
      },
      paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
      },
      fixedHeight: {
        height: 240,
      },

      backdrop: {
        zIndex: 999999,
        color: '#fff',
      },
      latestNewsPaper: {
        marginRight: 10,
        cursor: "default",
      }
});

class NewNavbar extends Component {
  constructor(props) {
    super(props);
    const initialTitle = this.getTitleFromPath(props.location.pathname);

    this.state = {
      islogout: false,
      name:"",
      surname:"",
      hasGivenSCOs: false,
      hasReceivedSCOs: false,
      impersonator:localStorage.getItem("impersonator"),
      isAdmin: null,
      setOpen: isMobile?false:true,
      tokenBalance: 0,
      selectedIndex: this.props.location.pathname,  
      color: "white",
      greyScreen:false,
      newUpdateAvailable:false,
      newMessages:false,
      selectedTitle:initialTitle,
      isAssistant:true,
      liveSystem: true,
      onlyMiniAssessment: true,
      isBeingAssisted:localStorage.getItem("isBeingAssisted")==="true"?true:false,
      openLeaveMessageModal:false,
      selectedCategory: "",
      messageText: "",
    };
  }

   handleDrawerOpen = () => {
        this.setState({
        setOpen:true
        })
    };

    returnToAdmin = async() =>{
      await aserver.logout(this, true);
    }

    handleDrawerClose = () => {
    this.setState({
        setOpen:false
        })  };

    openBackground=()=>{
      this.setState({   
        greyScreen:true
      })
    }

    showNewVersion=()=>{
      this.setState({
        newUpdateAvailable:true
      })
    }

    userProfileChanged=(newDetails)=>{
      this.setState({
        name: newDetails.name,
        surname: newDetails.surname
      });
    }

    updateUserProfile=(update)=>{
      this.setState(update);
    }

    toastMessage = (text, level) => {
      this.setState({
        message: text,
        level: level,
      })
      this.showToast()
    }

    showToast = () => {
      this.setState(
        {
          showToast: true
        },
        () => {
          setTimeout(() => this.setState({ showToast: false }), 3500);
        }
      );
    }
  

    fetchData = async () => {
      let coachId = localStorage.getItem("Id")
      let result = await aserver.get(`api/v2/coaches/${coachId}`);
       if(result.status === 200){
        this.setState({
          name: result.data.name,
          surname:result.data.surname,
          isAdmin: result.data.isAdmin,
          tokenBalance:result.data.tokenBalance,
          newMessages:result.data.newMessages,
          hasGivenSCOs: result.data.countOfGivenSCOs>0,
          hasReceivedSCOs: result.data.countOfReceivedSCOs>0,
          liveSystem: result.data.liveSystem,
          isAssistant: result.data.isAssistant,
          enableMiniAssessment: result.data.enableMiniAssessment,
          onlyMiniAssessment: result.data.onlyMiniAssessment,
          pronounSets: result.data.pronounSets,
        });
        localStorage.setItem('assessmentNames', JSON.stringify(result.data.assessmentNames));
        localStorage.setItem('teamNames', JSON.stringify(result.data.teamReportNames));
        if(this.state.tokenBalance >= 0){
          this.setState({
            color:"#99c93d"
          })
        }else{
          this.setState({
            color:" #f7993b"
          })
        }
      }else if (result.status === 403){
        localStorage.removeItem("Id");
        window.location='/coachportal/login';
      }
    };

    openLeaveMessageModal = ()=>{
      this.setState({
        openLeaveMessageModal:true
      })
    }

    submitMessage = async () => {
      const { selectedCategory, messageText } = this.state;
  
      if (!selectedCategory || !messageText.trim()) {
        alert("Please select a category and enter a message.");
        return;
      }
  
      const messageData = {
        category: selectedCategory,
        message: messageText,
      };

      const coachId = localStorage.getItem("Id")
      try {
        const submitResult = await aserver.post(`api/v2/coaches/${coachId}/leaveMessage`, messageData);  
        if (submitResult.status==200) {
          this.toastMessage("Thank you, successfully submitted.", "success")
          this.closeModal();
        } else {
          alert("There was an unexpected error while sending the message. Please try again later.");
          this.closeModal();
        }
      } catch (err) {
        console.log(err);
        this.closeModal();
      }

    };
  
    closeModal = () => {
      this.setState({ openLeaveMessageModal: false, selectedCategory: "", messageText: "" });
    };
    
    componentDidMount = () => {
      aserver.setContinueCallback(this.openBackground);
      aserver.setNewVersionAvailableCallback(this.showNewVersion)
      this.fetchData();
    };
    
    handleListItemClick = (event, index, title) => {
      this.setState({
        selectedIndex: index,
        selectedTitle: title
      })
      if(index === "/coachportal/messages"){
        this.setState({
          newMessages:false,
        })
      }
    };

    signOut = async() => {
        await aserver.logout(this, false);
    };

    continueToStayLoggedIn=(e)=>{
      aserver.processUserContinueResponse(e)
      this.setState({
        greyScreen:false, 
      })
    }

    componentDidUpdate(prevProps) {
      if (this.props.location !== prevProps.location) {
        this.updateTitle(this.props.location.pathname);
      }
    }
  
    componentDidMount() {
      this.updateTitle(this.props.location.pathname);
    }
  
    updateTitle = (pathname) => {
      const title = this.getTitleFromPath(pathname);
      this.setState({ selectedTitle: title });
    };

    getTitleFromPath = (pathname) => {
      const { match } = this.props;
      switch (pathname) {
        case `${match.path}/assessments`:
          return 'Assessments';
        case `${match.path}/sco-given`:
          return 'Secondary Coach Ownership Given';
        case `${match.path}/mini-assessments`:
          return 'Mini Assessments';
        case `${match.path}/email-templates`:
          return 'Email Templates';
        case `${match.path}/teams`:
          return 'Teams';
        case `${match.path}/billing`:
          return 'Billing';
        case `${match.path}/bulk-orders`:
          return 'Bulk Orders';
        case `${match.path}/help`:
          return 'Help';
        case `${match.path}/profile`:
          return 'Profile';
        case `${match.path}/team`:
          return `${localStorage.getItem("Team-Name")}`;
        case `${match.path}/messages`:
          return 'Messages';
        case `${match.path}/samples-and-brochures`:
          return 'Samples and Brochures';
        case `${match.path}/dashboard`:
        default:
          return 'Dashboard';
      }
    };

    render() {
      const classes = this.props.classes;
      const { match } = this.props;

        if (this.state.islogout) {
        return <Redirect to="/coachportal/login" />;
        }
        let Return = <></>
        if(this.state.impersonator === "true"){
          Return = 
          <> 
            <Button className="returnButton" variant="contained" id="secondary" type="submit" onClick={this.returnToAdmin}>Return to Coaches</Button>
          </>
        }

        let News =<></> 
        if(this.state.newUpdateAvailable){
          News =  <>
                    <Paper className={classes.latestNewsPaper}>
                      <p style={{color:"black", fontSize:10, padding:3,}}>There is a new version available. Click <u style={{cursor: "pointer"}} onClick={()=>window.location.reload(false)}>here</u> to refresh.<br></br> Then you can read what's new on the Help page.</p>
                    </Paper>
                  </>
        }

        return (
        <div className={classes.root}>
        <CssBaseline />
                <AppBar position="absolute" className={clsx(classes.appBar, this.state.setOpen && classes.appBarShift)}>
                    <Toolbar className={classes.toolbar}>
                      <IconButton
                          edge="start"
                          color="inherit"
                          aria-label="open drawer"
                          onClick={this.handleDrawerOpen}
                          className={clsx(classes.menuButton, this.state.setOpen && classes.menuButtonHidden)}
                      >
                          <MenuIcon />
                      </IconButton>
                      <img className="aephoria-logo" src={this.state.liveSystem?WhiteLogo:WhiteLogoSafeTest}alt="aephoria-logo"/>
                      <Header title={this.state.selectedTitle} />
                      <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}></Typography>
                      {isMobile?<></>:<Typography variant="caption" color="inherit" style={{ opacity: 0.75, marginRight: '1em', whiteSpace: 'nowrap' }}>
                        Times shown in your local time zone ({aserver.getLocalTimezoneLabel()})
                      </Typography>}
                      {Return}
                      {News}
                      <IconButton className="tokenNumber" disabled>
                        <span className="circle" style={ { backgroundColor: this.state.color} }> <div className="tokenBalance">{this.state.tokenBalance}</div></span>
                      </IconButton>
                    </Toolbar>
                </AppBar>
                <Drawer
                    variant="permanent"
                    classes={{
                    paper: clsx(classes.drawerPaper, !this.state.setOpen && classes.drawerPaperClose),
                    }}
                    open={this.state.setOpen}
                    onClick={isMobile?this.handleDrawerClose:null}
                >
                    <div className={classes.toolbarIcon}>
                      <Link to={`${match.path}/profile`} style={{ textDecoration: 'none', width: "100%" }}>
                      <ListItem
                        button
                        selected={this.state.selectedIndex === `${match.path}/profile`}
                        onClick={(event) => this.handleListItemClick(event, `${match.path}/profile`)} 
                      >
                        <ListItemIcon>
                          <img className="nav-icon" src={UserIcon}alt="user-icon"/>
                        </ListItemIcon>
                        <div style={{display: this.state.surname.length>8||this.state.name.length>8?"block":"flex"}}>
                          <h4 style={{margin:0}}>{this.state.name}&nbsp;</h4>
                          <h4 style={{margin:0}}>{this.state.surname}</h4>
                          <Badge overlap="rectangular" style={{display:this.state.isBeingAssisted?"block":"none"}} badgeContent="Assistant" color="secondary"></Badge>
                        </div>
                      </ListItem>
                      </Link>
                      <IconButton onClick={this.handleDrawerClose}>
                          <ChevronLeftIcon />
                      </IconButton>
                    </div>
                    <Divider />

                    <List>
                        <div>
                            <Link to={`${match.path}/dashboard`} style={{ textDecoration: 'none' }}>
                            <ListItem button
                              selected={this.state.selectedIndex === `${match.path}/dashboard`}
                              onClick={(event) => this.handleListItemClick(event, `${match.path}/dashboard`)}
                            >
                            <ListItemIcon>
                                <img className="nav-icon" src={DashboardIcon}alt="dashboard-icon"/>
                            </ListItemIcon>
                            <ListItemText primary="Dashboard" />
                            </ListItem>
                            </Link>

                            {(!this.state.onlyMiniAssessment)&&<Link to={`${match.path}/assessments`} style={{ textDecoration: 'none', display:this.state.isAssistant?"none":"block"  }}>
                            <ListItem button
                              selected={this.state.selectedIndex === `${match.path}/assessments`}
                              onClick={(event) => this.handleListItemClick(event, `${match.path}/assessments`)}
                            >
                            <ListItemIcon>
                              <img className="nav-icon" src={AssessmentsIcon}alt="assessments-icon"/>
                            </ListItemIcon>
                            <ListItemText primary="Assessments" />
                            </ListItem>
                            </Link>}

                            {this.state.enableMiniAssessment?
                            <Link to={`${match.path}/mini-assessments`} style={{ textDecoration: 'none', display:"block"  }}>
                                <ListItem
                                  button
                                  selected={this.state.selectedIndex === `${match.path}/mini-assessments`}
                                  onClick={(event) => this.handleListItemClick(event, `${match.path}/mini-assessments`)}
                                >
                                <ListItemIcon>
                                  <img className="nav-icon" src={AssessmentsIcon}alt="mini-assessments-icon"/>
                                </ListItemIcon>
                                <ListItemText primary="Mini-Assessments" />
                                </ListItem>
                            </Link>:<></>}

                            {(!this.state.onlyMiniAssessment)&&<Link to={`${match.path}/sco-given`} style={{ display:this.state.hasGivenSCOs?"block":"none", textDecoration: 'none' }}>
                            <ListItem button
                              selected={this.state.selectedIndex === `${match.path}/sco-given`}
                              onClick={(event) => this.handleListItemClick(event, `${match.path}/sco-given`, isMobile?"SCO Given":"Secondary Coach Ownership Given")}
                            >
                            <ListItemIcon>
                              <img className="nav-icon" src={AssessmentsIcon}alt="assessments-icon"/>
                            </ListItemIcon>
                            <ListItemText primary="SCO Given" />
                            </ListItem>
                            </Link>}

                            {(!this.state.onlyMiniAssessment)&&<Link to={`${match.path}/pairs`} style={{ textDecoration: 'none', display:this.state.isAssistant?"none":"block"  }}>
                                <ListItem
                                  button
                                  selected={this.state.selectedIndex === `${match.path}/pairs`}
                                  onClick={(event) => this.handleListItemClick(event, `${match.path}/pairs`)}
                                >
                                <ListItemIcon>
                                  <Badge overlap="rectangular" color="secondary" badgeContent="new">
                                    <img className="nav-icon" src={TeamsIcon}alt="teams-icon"/>
                                  </Badge>
                                </ListItemIcon>
                                <ListItemText primary="Pairs" />
                                </ListItem>
                            </Link>}

                            {(!this.state.onlyMiniAssessment)&&<Link to={`${match.path}/teams`} style={{ textDecoration: 'none', display:this.state.isAssistant?"none":"block"  }}>
                                <ListItem
                                  button
                                  selected={this.state.selectedIndex === `${match.path}/teams`}
                                  onClick={(event) => this.handleListItemClick(event, `${match.path}/teams`)}
                                >
                                <ListItemIcon>
                                  <img className="nav-icon" src={TeamsIcon}alt="teams-icon"/>
                                </ListItemIcon>
                                <ListItemText primary="Teams" />
                                </ListItem>
                            </Link>}

                            {(!this.state.onlyMiniAssessment)&&<Link className="hideNavItem" to={`${match.path}/email-templates`} style={{ textDecoration: 'none' }}>
                            <ListItem
                              button
                              selected={this.state.selectedIndex === `${match.path}/email-templates`}
                              onClick={(event) => this.handleListItemClick(event, `${match.path}/email-templates`)}
                            >
                            <ListItemIcon>
                              <img className="nav-icon" src={EmailIcon}alt="email-icon"/>
                            </ListItemIcon>
                            <ListItemText primary="Email Templates" />
                            </ListItem>
                            </Link>}

                            {(!this.state.onlyMiniAssessment)&&<Link to={`${match.path}/billing`} style={{ textDecoration: 'none', display:this.state.isAssistant?"none":"block"  }}>
                                <ListItem
                                  button
                                  selected={this.state.selectedIndex === `${match.path}/billing`}
                                  onClick={(event) => this.handleListItemClick(event, `${match.path}/billing`)}
                                >
                                <ListItemIcon>
                                  <img className="nav-icon" src={BalanceIcon}alt="billing-icon"/>
                                </ListItemIcon>
                                <ListItemText primary="Billing" />
                                </ListItem>
                            </Link>}

                            {(!this.state.onlyMiniAssessment)&&<Link to={`${match.path}/bulk-orders`} style={{ textDecoration: 'none', display:this.state.isAssistant?"none":"block"  }}>
                                <ListItem
                                  button
                                  selected={this.state.selectedIndex === `${match.path}/bulk-orders`}
                                  onClick={(event) => this.handleListItemClick(event, `${match.path}/bulk-orders`)}
                                >
                                <ListItemIcon>
                                  <img className="nav-icon" src={BalanceIcon}alt="bulk-orders-icon"/>
                                </ListItemIcon>
                                <ListItemText primary="Bulk Orders" />
                                </ListItem>
                            </Link>}

                            <Link className="hideNavItem" to={`${match.path}/samples-and-brochures`} style={{ textDecoration: 'none' }}>
                                <ListItem button
                                selected={this.state.selectedIndex === `${match.path}/samples-and-brochures`}
                                onClick={(event) => this.handleListItemClick(event, `${match.path}/samples-and-brochures`)}
                                >
                                <ListItemIcon>
                                  <img className="nav-icon" src={SamplesIcon}alt="samples-icon"/>
                                </ListItemIcon>
                                <ListItemText primary="Samples & Brochures" />
                                </ListItem>
                            </Link>

                            {(!this.state.onlyMiniAssessment)&&<Link className="hideNavItem" to={`${match.path}/messages`} style={{ textDecoration: 'none' }}>
                              <ListItem
                                button
                                selected={this.state.selectedIndex === `${match.path}/messages`}
                                onClick={(event) => this.handleListItemClick(event, `${match.path}/messages`)}
                              >
                                <ListItemIcon>
                                  <Badge overlap="rectangular" color="secondary" invisible={!this.state.newMessages} badgeContent="new">
                                    <img className="nav-icon" src={MessagesIcon}alt="message-icon"/>
                                  </Badge>
                                </ListItemIcon>
                                <ListItemText primary="Messages" />
                              </ListItem>
                            </Link>}

                            {(!this.state.onlyMiniAssessment)&&<Link className="hideNavItem" to={`${match.path}/help`} style={{ textDecoration: 'none' }}>
                            <ListItem
                              button
                              selected={this.state.selectedIndex === `${match.path}/help`}
                              onClick={(event) => this.handleListItemClick(event, `${match.path}/help`)}
                            >
                            <ListItemIcon>
                              <img className="nav-icon" src={HelpIcon}alt="help-icon"/>
                            </ListItemIcon>
                            <ListItemText primary="Help" />
                            </ListItem>
                            </Link>}

                            <Link to="/coachportal" style={{ textDecoration: 'none' }} onClick={this.signOut}>
                            <ListItem button>
                            <ListItemIcon>
                              <img className="nav-icon" src={LogoutIcon}alt="logout-icon"/>
                            </ListItemIcon>
                            <ListItemText primary="Log Out" />
                            </ListItem>
                            </Link>
                        </div>
                    </List>
                    <Divider />
                    <img className="notepad" src={Notepad} alt="aephoria-logo" onClick={this.openLeaveMessageModal}/>
                    <img className="navLogo" src={AephoriaLabLogo} alt="aephoria-logo"/>
                    {this.state.setOpen
                      ? <span className="helpButtonSpan">Help: <button className="helpButton" onClick={() => window.open("mailto:devteam@aephoriagroup.com")}>devteam@aephoriagroup.com</button></span>
                      : <button className="helpButton hideNavItem" onClick={() => window.open("mailto:devteam@aephoriagroup.com")}>Help...</button>}
                </Drawer>
                <main className={classes.content} onClick={isMobile?this.handleDrawerClose:null}>
                    <Switch>
                        <Route path={`${match.path}/assessments`} render={(props) => <Assessments {...props} updateLayout={this.fetchData} updateUserProfile={this.updateUserProfile} isSecondaryComponent={false} scoMode={'n/a'} pronounSets={this.state.pronounSets} hasReceivedSCOs={this.state.hasReceivedSCOs} />}/>
                        <Route path={`${match.path}/sco-given`} render={(props) => <Assessments {...props} isSecondaryComponent={true} scoMode={'given'} hasReceivedSCOs={this.state.hasReceivedSCOs} />}/>
                        <Route path={`${match.path}/mini-assessments`} component={MiniAssessments}/>
                        <Route path={`${match.path}/email-templates`} component={Template}/>
                        {/* <Route path={`${match.path}/projects`} component={Projects}/> */}
                        <Route path={`${match.path}/teams`} component={Teams}/>
                        <Route path={`${match.path}/pairs`} render={(props) => <Couples {...props} pronounSets={this.state.pronounSets} />}/>
                        <Route path={`${match.path}/billing`} component={Billing}/>
                        <Route path={`${match.path}/bulk-orders`} component={Orders}/>
                        <Route path={`${match.path}/help`} component={Help}/>
                        <Route path={`${match.path}/profile`}  render={(props) => <Profile {...props} isAssistant={this.state.isAssistant} profileChanged={this.userProfileChanged} />} />
                        <Route path={`${match.path}/team`} component={TeamMembers}/>
                        <Route path={`${match.path}/messages`} component={Messages}/>
                        <Route path={`${match.path}/samples-and-brochures`} component={Samples}/>
                        {/* <Route path={`${match.path}/clients`} render={(props) => <Clients {...props} updateLayout={this.fetchData}/>}/> */}
                        <Route exact path={`${match.path}/dashboard`} render={(props) => <Dashboard {...props} onlyMiniAssessment={this.state.onlyMiniAssessment} isAssistant={this.state.isAssistant} />}/>
                        <Route exact path={`${match.path}`} render={(props) => <Dashboard {...props} onlyMiniAssessment={this.state.onlyMiniAssessment} isAssistant={this.state.isAssistant} />}/>
                        <Redirect to={`${match.path}/dashboard`} />
                    </Switch>
                </main>
                <Backdrop className={classes.backdrop} open={this.state.greyScreen}>
                  <div>
                    <h3>You will be logged out in a minute. Click Continue to extend your session</h3>
                    <br></br>
                    <Button variant="contained" color="primary" type="submit" onClick={()=>this.continueToStayLoggedIn(true)}>Continue</Button><Button variant="contained" color="primary" type="submit" onClick={()=>this.continueToStayLoggedIn(false)}>Log Out</Button>
                  </div>
                </Backdrop>
                <Modal isOpen={this.state.openLeaveMessageModal} onClose={() => this.closeModal()}>
                  <h2>Leave A Message</h2>
                  <p>We love hearing from you. Tell us your thoughts! Share feedback and ideas, report issues, refer someone or more.</p>
                  <div className="radioButtonsDiv" onChange={(e) => this.setState({ selectedCategory: e.target.value })}>
                    <label>
                      <input type="radio" name="messageType" value="featureRequest" /><span> I have an idea/need.</span> 
                    </label>
                    <br />
                    <label>
                      <input type="radio" name="messageType" value="bugReport" /><span> Something is frustrating/wrong.</span>
                    </label>
                    <br />
                    <label>
                      <input type="radio" name="messageType" value="marketingLink" /><span> Request marketing link for big opportunity.</span>
                    </label>
                    <br />
                    <label>
                      <input type="radio" name="messageType" value="referBuddy" /><span> Refer a coach for training.</span>
                    </label>
                    <br />
                    <label>
                      <input type="radio" name="messageType" value="freeText" /><span> Something I want to share.</span>
                    </label>
                  </div>
                  <textarea 
                    rows="5" 
                    cols="50" 
                    id="freeText"
                    style={{ width: "100%", marginTop: "10px" }}
                    onChange={(e) => this.setState({ messageText: e.target.value })}
                    value={this.state.messageText} 
                  />
                  <p>Disclaimer: This is not an instant chat. We will respond to your email within one business day. </p>
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.submitMessage()}>Ok</Button>
                </Modal>
                <Toast
                  level={this.state.level}
                  message={this.state.message}
                  visible={this.state.showToast}
                />

        </div>
        );
    }
}

NewNavbar.propTypes = {
    classes: PropTypes.object.isRequired
  };

export default withStyles(styles)(withRouter(NewNavbar));